import { vtkObject } from '@kitware/vtk.js/interfaces'

export interface Field {
  key: string, // field name on return object
  path?: string, // override get field path if key is for display purposes
  fields?: Field[] // array of subfields
}

// recursive "object walker" configured by fields object
export const deriveVTKState: (fields: Field[], object: vtkObject) => { [index: string]: any } = (fields, object) => {
  if (!object) return

  return fields.reduce((p, f) => {
    if (f.key === undefined && f.path === undefined) return undefined
    
    let subObject
    // object.get(f.path) fails because some fields don't exist
    // until functions are called like object.getActors()
    const call = typeof f.path !== 'undefined' ? 
      `get${f.path.charAt(0).toUpperCase() + f.path.slice(1)}` 
      : 
      `get${f.key.charAt(0).toUpperCase() + f.key.slice(1)}`
    try {
      subObject = object[call]()
    } catch {
      try {
        // this is run on custom params
        const key = f.path ?? f.key
        subObject = object.get(key)[key]
      } catch {
        return { ...p, [f.key]: undefined }
      }
    }

    if (typeof subObject === 'undefined') return { ...p, [f.key]: undefined }

    if (f.fields) {
      // returns true if subObject.length === 0
      // @ts-ignore
      if (typeof subObject.length !== 'undefined') {
        return {
          // @ts-ignore
          ...p, [f.key]: subObject.map(val => {
            return deriveVTKState(f.fields, val)
          })
        }
      } //@ts-ignore 
      else return { ...p, [f.key]: deriveVTKState(f.fields, subObject) }
    }
    return { ...p, [f.key]: subObject }
  }, {} as { [index: string]: any })
}